import React, { useState } from "react";
import Reveal from "./Reveal";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "Co přesně znamená voucher s +50 % hodnotou?",
    a: "Běžná cena programu Prestige je 10 499 Kč. Koupíte-li ho formou voucheru předem, zaplatíte 6 999 Kč — tedy o 33 % méně, než kdybyste přišli bez voucheru. Voucher není kredit na útratu, je to konkrétní služba s přesně definovaným obsahem.",
  },
  {
    q: "Jakou chemii a vybavení používáte?",
    a: "Pracujeme výhradně s prémiovými značkami: Koch Chemie (Německo), Gyeon (Korea) a Swiss Wax (Švýcarsko) — to je to nejlepší, co trh detailingu nabízí. Pro leštění laku používáme profi polishery Flex a Rupes, extrakční jednotky Kärcher Puzzi a IR lampy pro aplikaci sklokeramiky. Žádné kompromisy.",
  },
  {
    q: "Jakou mají pracovníci zkušenost?",
    a: "Naši detailéři mají za sebou více než 10 let praxe. Certifikovaná školení od výrobců chemie, pravidelné kalibrace technik. CarSpa působí na českém trhu od roku 2014 a připravuje auta pro Škoda Auto, Toyota, Volvo Průhonice, UniCredit Leasing, Drivalia, AAAauto a další značky.",
  },
  {
    q: "Jak dlouho voucher platí a je přenositelný?",
    a: "Platnost voucheru je 3 roky od aktivace. Je 100% přenositelný — můžete ho darovat partnerovi, rodičům, kolegovi nebo klientovi. Při rezervaci stačí uvést unikátní kód z voucheru.",
  },
  {
    q: "Můžu voucher uplatnit v obou pobočkách?",
    a: "Ano. Voucher je platný v obou pobočkách — Čestlice (Aquapalace) i Butovice (Coral Office Park). Jakmile otevřeme další lokality, automaticky i tam, bez navýšení ceny.",
  },
  {
    q: "Jak funguje sklokeramická záruka 2 roky?",
    a: "U programů Prestige a Supreme aplikujeme sklokeramickou ochranu Koch a na nanesenou vrstvu dáváme písemnou záruku 2 roky. Pokud by v záruční době došlo k degradaci ochrany, opravíme bezplatně. Pro trvanlivost je důležité dodržet pokyny k údržbě, které předáme při převzetí vozu.",
  },
  {
    q: "Jak probíhá platba a vystavení voucheru?",
    a: "Po odeslání formuláře se vám do 24 hodin ozveme telefonicky nebo e-mailem s platebními údaji a obchodními podmínkami k voucheru (přílohou e-mailu). Platíte bankovním převodem. Po připsání platby vám zašleme finální digitální voucher s unikátním kódem a QR kódem.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="relative py-20 sm:py-24 md:py-36 bg-[#070707]">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 md:px-10">
        <Reveal className="mb-12 md:mb-16 max-w-3xl">
          <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
            Časté otázky
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Než se rozhodnete.
            <br />
            <span className="italic text-gold-gradient">Bez nejasností.</span>
          </h2>
        </Reveal>

        <div className="divide-y divide-white/5 border-y border-white/5">
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={i} delay={i * 60}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-item-${i}`}
                  aria-expanded={isOpen}
                  className="w-full text-left py-5 sm:py-6 md:py-7 px-1 sm:px-2 md:px-4 flex items-start justify-between gap-4 sm:gap-6 group"
                >
                  <span className={`font-display text-base sm:text-xl md:text-2xl leading-tight transition-colors ${isOpen ? "text-[#D4AF37]" : "text-white group-hover:text-[#D4AF37]"}`}>
                    {item.q}
                  </span>
                  <span className="shrink-0 mt-1 text-[#D4AF37]">
                    {isOpen ? <Minus size={18} strokeWidth={1.2} /> : <Plus size={18} strokeWidth={1.2} />}
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-500 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100 pb-6 sm:pb-7 px-1 sm:px-2 md:px-4" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="text-sm sm:text-base text-zinc-400 font-light leading-relaxed max-w-3xl">
                      {item.a}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
